export default "__VITE_ASSET__BtgclyPP__"